module.exports = __webpack_public_path__ + "img/receiver-link-icon.9542efb9.png";